let pendingBundle = null

export function loadBradleyProjectsBundle() {
  if (!pendingBundle) {
    pendingBundle = Promise.all([
      import('./bradley-projects.service.js'),
      import('../utils/bradley-project.util.js'),
      import('../utils/bradley-project-files.util.js'),
      import('../analytics/bradley-project-analytics.telemetry.js'),
    ]).then(([service, projectUtil, filesUtil, analytics]) => ({
      ...service,
      ...projectUtil,
      ...filesUtil,
      ...analytics,
    }))
  }

  return pendingBundle
}

export function resetBradleyProjectsBundleForTests() {
  pendingBundle = null
}
